// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-custom.no-flip-card[data-v-12172b5e]:hover,.no-flip-card[data-v-12172b5e]:hover{transform:none!important;-webkit-transform:none!important;-webkit-box-shadow:0 0 30px 0 rgba(82,63,105,.05)!important;box-shadow:0 0 30px 0 rgba(82,63,105,.05)!important}", ""]);
// Exports
module.exports = exports;
